import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';

export interface AppNavItem extends MenuItem {
    permissions?: string[];
    status: boolean;
    children?: AppNavItem[];
}

const Rawnavitems: AppNavItem[] = [
    {
        label: 'Inicio',
        icon: 'pi pi-home',
        routerLink: ['/presorteo/megaloto/home'],
        status: true
    },
    {
        label: 'Autenticación',
        icon: 'pi pi-shield',
        status: true,
        children: [
            {
                label: 'Usuarios',
                icon: 'pi pi-users',
                routerLink: ['/presorteo/auth/user'],
                permissions: ['auth.user.get'],
                status: true
            },
            {
                label: 'Roles',
                icon: 'pi pi-sitemap',
                routerLink: ['/presorteo/auth/rol'],
                permissions: ['auth.user.get'],
                status: true
            },
            // {
            //     label: 'Permisos',
            //     icon: 'pi pi-key',
            //     routerLink: ['/presorteo/auth/permission'],
            //     permissions: ['auth.permission.get'],
            //     status: true
            // },
        ],
    },
    {
        label: 'Configuración presorteo',
        icon: 'pi pi-cog',
        permissions: ['core.config.presorteo'],
        routerLink: ['/presorteo/megaloto/config-presorteo'],
        status: true
    },
    {
        label: 'Generar selección',
        icon: 'pi pi-sync',
        permissions: ['core.generate-selection.get'],
        routerLink: ['/presorteo/megaloto/generate-selection'],
        status: true
    },
    {
        label: 'Vista de presorteo',
        icon: 'pi pi-stop',
        permissions: ['core.view-config.get'],
        routerLink: ['/presorteo/megaloto/view-config'],
        status: true
    },
    {
        label: 'Reporte de selección',
        icon: 'pi pi-bars',
        permissions: ['core.report-gna.get'],
        routerLink: ['/presorteo/megaloto/report-onj'],
        status: true
    }
];

const RawnavitemsMiloto: AppNavItem[] = [
    {
        label: 'Inicio-miloto',
        icon: 'pi pi-home',
        routerLink: ['/presorteo/miloto/home'],
        status: true
    },
    {
        label: 'Autenticación',
        icon: 'pi pi-shield',
        status: true,
        children: [
            {
                label: 'Usuarios',
                icon: 'pi pi-users',
                routerLink: ['/presorteo/auth/user'],
                permissions: ['auth.user.get'],
                status: true
            },
            {
                label: 'Roles',
                icon: 'pi pi-sitemap',
                routerLink: ['/presorteo/auth/rol'],
                permissions: ['auth.user.get'],
                status: true
            },
            {
                label: 'Permisos',
                icon: 'pi pi-key',
                routerLink: ['/presorteo/auth/permission'],
                permissions: ['auth.permission.get'],
                status: true
            },
        ],
    },
    {
        label: 'Configuración baloteras- balotas',
        icon: 'pi pi-box',
        permissions: ['core.type-machine.get'],
        routerLink: ['/presorteo/miloto/ballots-configuration'],
        status: true
    },
    {
        label: 'Configuración presorteo',
        icon: 'pi pi-cog',
        permissions: ['core.config.presorteo'],
        routerLink: ['/presorteo/miloto/config-presorteo'],
        status: true
    },
    {
        label: 'Generar selección',
        icon: 'pi pi-sync',
        permissions: ['core.generate-selection.get'],
        routerLink: ['/presorteo/miloto/generate-selection'],
        status: true
    },
    {
        label: 'Vista de presorteo',
        icon: 'pi pi-stop',
        permissions: ['core.view-config.get'],
        routerLink: ['/presorteo/miloto/view-config'],
        status: true
    },
    {
        label: 'Reporte de selección',
        icon: 'pi pi-bars',
        permissions: ['core.report-gna.get'],
        routerLink: ['/presorteo/miloto/report-onj'],
        status: true
    }
];

const RawnavitemsColorloto: AppNavItem[] = [
    {
        label: 'Inicio-colorloto',
        icon: 'pi pi-home',
        routerLink: ['/presorteo/colorloto/home'],
        status: true
    },
    {
        label: 'Autenticación',
        icon: 'pi pi-shield',
        status: true,
        children: [
            {
                label: 'Usuarios',
                icon: 'pi pi-users',
                routerLink: ['/presorteo/auth/user'],
                permissions: ['auth.user.get'],
                status: true
            },
            {
                label: 'Roles',
                icon: 'pi pi-sitemap',
                routerLink: ['/presorteo/auth/rol'],
                permissions: ['auth.user.get'],
                status: true
            },
            {
                label: 'Permisos',
                icon: 'pi pi-key',
                routerLink: ['/presorteo/auth/permission'],
                permissions: ['auth.permission.get'],
                status: true
            },
        ],
    },
    {
        label: 'Configuración baloteras- balotas',
        icon: 'pi pi-box',
        permissions: ['core.type-machine.get'],
        routerLink: ['/presorteo/colorloto/ballots-configuration'],
        status: true
    },
    {
        label: 'Configuración presorteo',
        icon: 'pi pi-cog',
        permissions: ['core.config.presorteo'],
        routerLink: ['/presorteo/colorloto/config-presorteo'],
        status: true
    },
    {
        label: 'Generar selección',
        icon: 'pi pi-sync',
        permissions: ['core.generate-selection.get'],
        routerLink: ['/presorteo/colorloto/generate-selection'],
        status: true
    },
    {
        label: 'Vista de presorteo',
        icon: 'pi pi-stop',
        permissions: ['core.view-config.get'],
        routerLink: ['/presorteo/colorloto/view-config'],
        status: true
    },
    {
        label: 'Reporte de selección',
        icon: 'pi pi-bars',
        permissions: ['core.report-gna.get'],
        routerLink: ['/presorteo/colorloto/report-onj'],
        status: true
    }
];

@Injectable({
    providedIn: 'root'
})
export class AppSettingsService {

    private parseNavchildren: AppNavItem[];

    constructor(private cookieService: CookieService) { }

    get game() {
        let game = this.cookieService.getObject('game') as { game: string };
        return game.game;
    }

    get rawNavchildren(): Promise<AppNavItem[]> {
        if (this.parseNavchildren == null) {
            this.parseNavchildren = [];
            const tempSub: Subscription = null;
            return new Promise<AppNavItem[]>((resolve) => {
                this.parseNavchildren = (this.game === "megaloto" ? Rawnavitems : this.game === 'miloto' ? RawnavitemsMiloto : RawnavitemsColorloto).filter(item => item.status === undefined || item.status).map(item => {
                    return item;
                });
                resolve(this.parseNavchildren);
            }
            ).finally(() => { if (tempSub) { tempSub.unsubscribe(); } });
        }
        return new Promise<AppNavItem[]>(resolve => resolve(this.parseNavchildren));
    }

}
